import { type Scope, createContextScope } from '@radix-ui/react-context'
import { RadioButton } from './components/radio-button'
import { RadioHelperText } from './components/radio-helpertext'
import { RadioLabel } from './components/radio-label'

import type {
  RadioContext,
  RadioScopedProps,
  TRadioGroupProps,
  TRadioProps,
} from './radio.types'

const DISPLAY_NAME = 'Radio'

const RadioRoot = (props: RadioScopedProps<TRadioProps & TRadioGroupProps>) => {
  const {
    size,
    children,
    disabled,
    readOnly,
    defaultValue,
    legend,
    error,
    iconOnly,
    __scopeRadio,
    ...rest
  } = props

  return (
    <RadioProvider
      {...props}
      size={size}
      disabled={disabled}
      readOnly={readOnly}
      error={error}
      scope={__scopeRadio}
      iconOnly={iconOnly}
      selectedValue={defaultValue}
    >
      <fieldset {...rest} className="flex flex-col border-none">
        {children}
      </fieldset>
    </RadioProvider>
  )
}

RadioRoot.displayName = DISPLAY_NAME

/*
----------------------------------------------------------------
Scope Definition
----------------------------------------------------------------
*/

const [createRadioContext] = createContextScope(DISPLAY_NAME)

export const [RadioProvider, useRadioContext]: readonly [
  ProviderType<RadioContext>,
  (consumerName: string, scope: Scope) => RadioContext,
] = createRadioContext<RadioContext>(DISPLAY_NAME)

/*
----------------------------------------------------------------
Composition Export
----------------------------------------------------------------
*/

export const Radio = {
  Root: RadioRoot,
  Button: RadioButton,
  Label: RadioLabel,
  Helper: RadioHelperText,
}
